module.exports = __webpack_public_path__ + "static/media/29BDOS21.9d6fb743.jpg";